import { render, staticRenderFns } from "./mBadge.vue?vue&type=template&id=402e89a8"
import script from "./mBadge.vue?vue&type=script&lang=js"
export * from "./mBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports